import type { UserIdentityShape } from '@/components/profile/user-identity';

export function userIdentityKey(identity: UserIdentityShape, fallback: string): string {
  return identity.userId ?? identity.walletAddress ?? identity.handle ?? fallback;
}
